<template>
  <v-card>
    <v-layout mx-4 wrap>
      <v-flex md4>
        <v-text-field
          name="passport"
          label="Passaporte"
          id="passport"
          v-model="customer.passportNumber"
        ></v-text-field>
      </v-flex>
      <v-flex md4>
        <DatePicker
          name="passportExpiryDate"
          label="Vencimento do Passaporte"
          id="passportExpiryDate"
          v-model="customer.passportExpiryDate"
        />
      </v-flex>
      <v-flex md4>
        <v-text-field
          name="shirtSize"
          label="Tamanho da Camisa"
          id="shirtSize"
          v-model="customer.shirtSize"
        ></v-text-field>
      </v-flex>
      <v-flex md8>
        <v-text-field
          name="healthInsuranceProvider"
          label="Plano de Saúde"
          id="healthInsuranceProvider"
          v-model="customer.healthInsuranceProvider"
        ></v-text-field>
      </v-flex>
      <v-flex md4>
        <v-text-field
          name="bloodType"
          label="Tipo Sanguíneo"
          id="bloodType"
          v-model="customer.bloodType"
        ></v-text-field>
      </v-flex>
      <v-flex md12>
        <v-textarea
          name="diseases"
          label="Problemas de Saúde"
          id="diseases"
          v-model="customer.diseases"
        ></v-textarea>
      </v-flex>
      <v-flex md12>
        <v-textarea
          name="medication"
          label="Medicação Utilizada"
          id="medication"
          v-model="customer.medication"
        ></v-textarea>
      </v-flex>
    </v-layout>
  </v-card>
</template>
<script>
import DatePicker from "@/components/Shared/DatePicker";
export default {
  components: {
    DatePicker
  },
  props: ["customer"]
};
</script>
